export default __webpack_public_path__ + "static/media/margherita.683bc9bb.jpg";